import { useState } from 'react'
import { Route, Routes } from 'react-router-dom'

import { Header, PolicyBanner } from './components/Header'
import { Sidebar, SidebarContent } from './components/Sidebar'
import { DataManagement } from './components/panels/DataManagement'
import { CampaignStudio } from './pages/CampaignStudio'
import { DataExplorer } from './pages/DataExplorer'
import { Home, QuestionPage } from './pages/Questions'

export function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      {/* Sidebar para desktop con colapsado */}
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Drawer de móvil */}
      {mobileMenuOpen ? (
        <div className="fixed inset-0 z-50 md:hidden">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setMobileMenuOpen(false)} />
          <div className="bg-card absolute inset-y-0 left-0 w-72 shadow-2xl border-r" role="dialog" aria-modal="true">
            <SidebarContent onNavigate={() => setMobileMenuOpen(false)} />
          </div>
        </div>
      ) : null}

      <div className="flex min-w-0 flex-1 flex-col transition-all duration-300">
        <Header
          onOpenMenu={() => setMobileMenuOpen(true)}
          sidebarCollapsed={sidebarCollapsed}
          onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
        />
        <main className="mx-auto w-full max-w-[1680px] flex-1 px-4 py-6 sm:px-6 2xl:px-8 sm:py-8">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/explorer" element={<DataExplorer />} />
            <Route path="/studio" element={<CampaignStudio />} />
            <Route path="/when" element={<QuestionPage question="when" />} />
            <Route path="/who" element={<QuestionPage question="who" />} />
            <Route path="/what" element={<QuestionPage question="what" />} />
            <Route path="/sources" element={<DataManagement />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <PolicyBanner />
      </div>
    </div>
  )
}